import $ from 'jquery';

let $youtube = $('.youtube__overlay');

$youtube.on('click', ev => {
    let $parent = $(ev.currentTarget).parents('.youtube').first();
    let $iframe = $($parent.find('*[data-embed-code]').attr('data-embed-code'));
    $iframe.attr('allowfullscreen', '');
    $parent.html('');
    $parent.append($iframe);
});

consentApi.on('enable:youtube', _ => {
    $('.youtube--youtube .youtube__overlay').trigger('click');
});
consentApi.on('enable:vimeo', _ => {
    $('.youtube--vimeo .youtube__overlay').trigger('click');
});
